export default __webpack_public_path__ + "static/media/Amazon.e4d572b1.png";